var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-8"},[_c('h1',[_c('div',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.title))]),(_vm.code)?_c('code',{staticClass:"text-primary"},[_vm._v("404")]):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }